
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.25 15.625H2.5L15 4.375l12.5 11.25h-3.75v10h-7.5v-7.5h-2.5v7.5h-7.5v-10zm15-2.262L15 7.738l-6.25 5.625v9.762h2.5v-7.5h7.5v7.5h2.5v-9.762z","fill":"#fff"}})])
          )
        }
      }
    